@if (file$ | async; as file) {
  <form [formGroup]="form" class="grow" iczAutoFocus>
    <div class="col-24 grow">
      @let storageUnitId = $any(fileDetailService.object)?.storageUnitId;

      @if (storageUnitId) {
        <icz-storage-unit-association-alert
          [parentEntityType]="file.entityType!"
          [storageUnit]="storageUnit"
          [isStorageUnitUnavailable]="isStorageUnitUnavailable"
        ></icz-storage-unit-association-alert>
      }
      @if (file.caseFile) {
        <icz-case-file-association-alert
          [class.mt--8]="storageUnitId"
          [parentEntityType]="file.entityType!"
          [caseFileInfo]="caseFileInfo"
          [isCaseFileInfoUnavailable]="isCaseFileInfoUnavailable"
        ></icz-case-file-association-alert>
      }
      @if (strongCrossReferenceCount > 0) {
        <icz-object-association-alert
          [class.mt--8]="storageUnitId || file.caseFile"
          [associatedObjectClass]="ObjectClass.FILE"
          [heading]="strongCrossReferenceHeader"
          [isContentExpandable]="true"
        >
          <div class="col-8 my-8">
            @for (fileRef of strongCrossReferenceFiles; track fileRef.id) {
              <div>
                <a class="p-4" iczLinkWithoutHref (click)="openFileDetail(fileRef!)">
                  <span class="ref-number">{{ fileRef.refNumber }}</span>
                </a>
                <span>({{fileRef!.subject}})</span>
              </div>
            }
          </div>
        </icz-object-association-alert>
      }
      @if (file.fileCabinetId) {
        <icz-file-cabinet-association-alert
          [class.mt--8]="storageUnitId || file.caseFile || strongCrossReferenceCount > 0"
          [parentEntityType]="file.entityType!"
          [fileCabinetInfo]="fileCabinetInfo"
          [isFileCabinetInfoUnavailable]="isFileCabinetInfoUnavailable"
        ></icz-file-cabinet-association-alert>
      }
      <icz-section [label]="('Spisová značka' | translate) + ': ' + getRefNumberValue(file)" boxed>
        @if (file.refNumber) {
          <icz-copy-to-clipboard-button
            sectionHeader
            size="small"
            [text]="file.refNumber"
          ></icz-copy-to-clipboard-button>
        }
        <div class="row">
          <icz-form-field class="grow-2" label="Věc" formControlName="subject" [autoSizeMax]="3"></icz-form-field>
          <ng-container formGroupName="uid">
            <icz-form-field label="UID - Unikátní identifikátor" formControlName="uid" class="grow-1"></icz-form-field>
          </ng-container>
        </div>
        <div class="row">
          <icz-form-field class="grow-2" label="Popis" formControlName="description" [autoSizeMax]="6"></icz-form-field>
          <div class="row grow">
            <icz-form-field class="grow" label="Značka" formControlName="label"></icz-form-field>
            <icz-form-autocomplete class="grow" label="Forma" formControlName="fileForm"
            [options]="fileFormOptions"></icz-form-autocomplete>
          </div>
        </div>
        <div class="row">
          <icz-form-field [class]="noteFieldGrowClass" label="Poznámka" formControlName="note" [autoSizeMax]="6"></icz-form-field>
          <icz-form-autocomplete class="grow" label="Stav" formControlName="fileState" [options]="fileStateOptions"></icz-form-autocomplete>
          @if (isFileSuspended) {
            <icz-date-picker label="Termín obnovení řízení" formControlName="resumptionDeadlineAt" class="grow" outputFormat="dateTime"></icz-date-picker>
          }
          @if (!isFileSettledOrClosed) {
            <icz-date-picker label="Termín vyřízení" formControlName="resolutionDate" class="grow" outputFormat="dateTime"></icz-date-picker>
          }
        </div>
        <div class="row">
          <icz-form-autocomplete class="grow owner-field" label="Držitelé" formControlName="holderFunctionalPositionIds"
          [autoSizeMax]="6" [options]="functionalPositionOptions$ | async" [isMultiselect]="true"></icz-form-autocomplete>
          <icz-form-autocomplete class="grow owner-field" label="Zpracovatel" formControlName="ownerFunctionalPositionId"
          [autoSizeMax]="6" [options]="functionalPositionOptions$ | async"></icz-form-autocomplete>
        </div>
      </icz-section>
      <div class="row-24 grow pb-64">
        <div class="col-24 grow">
          @if (isFileObject(file) && isFileSettledOrClosed && settlement) {
            <icz-section label="Vyřízení spisu" boxed>
              <icz-form-autocomplete class="grow-3" label="Kdo vyřídil" [value]="settlement!.auditInfo!.createdByFunctionalPositionId"
              [options]="functionalPositionOptions$ | async" [fieldDisabled]="true"></icz-form-autocomplete>
              @if (settlementType === SettlementType.BY_OTHER_METHOD) {
                <icz-form-field [fieldDisabled]="true" label="Způsob vyřízení" [value]="otherSettlementMethod" class="grow"></icz-form-field>
              } @else {
                <icz-form-autocomplete label="Způsob vyřízení" class="grow" [value]="settlement!.type" [options]="settlementTypeOptions" [fieldDisabled]="true"></icz-form-autocomplete>
              }
              <div class="row">
                <icz-date-picker label="Datum vyřízení" class="grow" [value]="settlement!.settlementDate" [fieldDisabled]="true"></icz-date-picker>
                <icz-date-picker label="Datum uzavření" class="grow" [value]="$any(file).closureDate" [fieldDisabled]="true"></icz-date-picker>
              </div>
              @if (settlementDocument) {
                <div>
                  <icz-label class="icz-body-1 mb-4" label="Vyřizující dokument"></icz-label>
                  <icz-entity-item
                    [entity]="settlementDocument"
                  ></icz-entity-item>
                </div>
              }
              @if (settlementType === SettlementType.BY_RECORD) {
                <icz-form-field label="Důvod vyřízení" [value]="settlement!.reason" [fieldDisabled]="true"></icz-form-field>
                <icz-form-field label="Obsah vyřízení" [value]="settlement!.content" [fieldDisabled]="true"></icz-form-field>
              }
            </icz-section>
            @if (isFileClosed) {
              <icz-section label="Vyřazení" boxed>
                <div class="row">
                  <icz-form-field class="grow" formControlName="disposalYear" label="Rok vyřazení podle skartačního režimu"></icz-form-field>
                  <icz-form-field class="grow" formControlName="disposalOperationCode" label="Výsledný skartační znak"></icz-form-field>
                </div>
              </icz-section>
            }
          }
          @if (isInExternalApplication) {
            <icz-section label="Zpracování v externí aplikaci" boxed>
              <icz-form-autocomplete label="Externí aplikace" formControlName="issdId"
              [options]="issdApplicationOptions$ | async"></icz-form-autocomplete>
            </icz-section>
          }
          @if (canShowFileProfile(file) || applicationConfigService.objectExistenceCheckObjectRepresentingSubjectVisible()) {
            <icz-section label="Reprezentující subjekt" boxed>
              <icz-portrait [subject]="representingSubject$ | async" [object]="file$ | async" [showDatabox]="true"></icz-portrait>
            </icz-section>
          }
          <icz-section label="Třídění" boxed>
            @if (strongCrossReferenceCount > 0) {
              <icz-alert severity="info" [heading]="leadingFileInfoText" class="mb-8">
                @if (!isLeadingFile) {
                  <div content class="row mt-8">
                    <icz-object-class-icon [objectClass]="ObjectClass.FILE"></icz-object-class-icon>
                    <div>
                      <a class="p-4" iczLinkWithoutHref (click)="openFileDetail(leadingFile!)">
                        <span class="ref-number">{{ leadingFile!.refNumber }}</span>
                      </a>
                      <span>({{leadingFile!.subject}})</span>
                    </div>
                  </div>
                }
              </icz-alert>
            }
            <icz-file-type-selector [form]="form" controlName="fileTypeId" class="grow"></icz-file-type-selector>
            <icz-entity-class-selector
              [form]="form"
              controlName="entityClassId"
              [selectorEntityClassType]="file.caseFile ? null : EntityClassType.DOCUMENT_FILE"
              [usage]="EntityClassSelectorUsage.OFFICER_CURRENT_WITH_V"
              [showPopupDetails]="true"
            ></icz-entity-class-selector>
            <icz-disposal-schedule-retention-trigger-widget
              [entityClassId]="entityClassId"
              [useValuesFromForm]="isFileSettledOrClosed"
              [retentionTriggerWidgetMode]="retentionTriggerValidationMode"
              [form]="form"
            ></icz-disposal-schedule-retention-trigger-widget>
          </icz-section>
        </div>
        <div class="col-24 grow">
          <icz-section label="Základní informace" boxed>
            <icz-form-field label="Související evidence" formControlName="relatedEvidence"></icz-form-field>
            <div class="row">
              <ng-container formGroupName="auditInfo">
                <icz-date-picker label="Založeno" formControlName="createdAt" class="grow"></icz-date-picker>
                <icz-date-picker label="Poslední úprava" formControlName="modifiedAt" class="grow"></icz-date-picker>
              </ng-container>
            </div>
            @if (isFileDeactivated) {
              <icz-form-field [fieldDisabled]="true" label="Zrušil" [value]="auditInfo.modifiedByFunctionalPositionId | findFunctionalPositionById | async"></icz-form-field>
              <ng-container formGroupName="deactivateAuditInfo">
                <icz-date-picker formControlName="deactivationDate"
                                 label="Datum zrušení"  outputFormat="dateTime">
                </icz-date-picker>
                <icz-form-field label="Důvod zrušení" formControlName="deactivationReason"></icz-form-field>
              </ng-container>
            }
            <icz-form-autocomplete label="Způsob vedení spisu" formControlName="fileHandlingType" [options]="fileHandlingTypeOptions"></icz-form-autocomplete>
          </icz-section>
          <icz-section label="Zmocnění" boxed>
            <icz-empowerment formControlName="empowerment"></icz-empowerment>
          </icz-section>
          <icz-section label="Specifické" boxed>
            <icz-security-category-selector
              [form]="form"
              controlName="securityCategoryId"
            ></icz-security-category-selector>
            <icz-keywords-selector [form]="form" controlName="keywordIds"></icz-keywords-selector>
            <icz-custom-fields-form
              [form]="form"
              arrayName="customFieldValues"
              [entityTypes]="[EntityType.FILE]"
              [fileTypeId]="fileTypeId"
              [useCase]="CustomFieldsFormUseCase.CREATION_OR_UPDATE"
              [validityReferenceDate]="customFieldsValidityReferenceDate"
            ></icz-custom-fields-form>
          </icz-section>
          @if (isInRegistryOffice) {
            <icz-object-detail-preview-transfer-info-section
              [transferWithMainEntity]="registryOfficeTransfer!"
            ></icz-object-detail-preview-transfer-info-section>
          }
          @if (fileForm === FileForm.ANALOG || fileForm === FileForm.HYBRID) {
            <icz-section label="Uložení spisu" boxed>
              @if (fileState === FileState.CLOSED) {
                <icz-form-field label="Uložené množství" [fieldDisabled]="true" [value]="$any(fileDetailService.counts.getCount(FileDetailCountType.CONTENT))"></icz-form-field>
              }
              <icz-form-field label="Fyzické uložení" formControlName="physicalLocation"></icz-form-field>
            </icz-section>
          }
        </div>
      </div>
    </div>
  </form>
}
